export default __webpack_public_path__ + "static/media/brainstorm.789dd090.png";